/**
 * Dependency-free CAML/XML string helpers, extracted verbatim from FileFilterHelper
 * (which re-exports them) so pure, unit-testable modules can import them without
 * FileFilterHelper's auth/service import chain.
 */

export const escapeXml = (unsafe: string): string => {
    if (!unsafe) return '';
    return unsafe.replace(/[<>&'"]/g, function (c) {
        switch (c) {
            case '<': return '&lt;';
            case '>': return '&gt;';
            case '&': return '&amp;';
            case '\'': return '&apos;';
            case '"': return '&quot;';
            default: return c; // Should not happen with the regex
        }
    });
}

/**
 * Recursively builds a linearly nested chain of <Or> or <And> clauses.
 * @param conditions An array of pre-formatted CAML condition strings.
 * @param operator The operator name ('Or' or 'And').
 * @returns A single CAML string representing the linearly nested structure, or an empty string if no conditions.
 */
export const buildLinearRecursiveCAML = (conditions: string[], operator: "Or" | "And"): string => {
    const count = conditions.length;
    if (count === 0) return "";
    if (count === 1) return conditions[0];

    const remainingConditions = conditions.slice(0, count - 1);
    const lastCondition = conditions[count - 1];
    const nestedStructure = buildLinearRecursiveCAML(remainingConditions, operator);

    if (!nestedStructure) return lastCondition; // Should only happen if remainingConditions had one item
    return `<${operator}>${nestedStructure}${lastCondition}</${operator}>`;
}
